import {MODALS_IDS} from '@Components/modal-container';

export const isPageNavigationBlocked = (): boolean => {
  const state = window.PMW.redux.store.getState();

  if (state.posterEditor.isTimelineModeActive) {
    return true;
  }

  if (state.modals.modalsHashmap[MODALS_IDS.POSTER_EDITOR_PAGE_COLOR_PALETTE_STYLES_MODAL]?.isOpen) {
    return true;
  }

  return false;
};
